import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export type SortKey =
  | "featured"
  | "price-asc"
  | "price-desc"
  | "rating"
  | "duration";

type Props = {
  q: string;
  setQ: (v: string) => void;
  difficulty: string;
  setDifficulty: (v: string) => void;
  sort: SortKey;
  setSort: (v: SortKey) => void;
};

export const DIFFICULTIES = ["All", "Easy", "Medium", "Hard"];

const SORTS: { value: SortKey; label: string }[] = [
  { value: "featured", label: "Featured" },
  { value: "price-asc", label: "Price: low → high" },
  { value: "price-desc", label: "Price: high → low" },
  { value: "rating", label: "Top rated" },
  { value: "duration", label: "Duration" },
];

const FilterBar = ({
  q,
  setQ,
  difficulty,
  setDifficulty,
  sort,
  setSort,
}: Props) => {
  return (
    <div className="sticky top-[58px] z-40 border-y border-line-200 bg-sand/90 backdrop-blur-sm">
      <div className="mx-auto flex max-w-[1320px] flex-wrap items-center gap-3.5 px-6 py-3.5 md:px-12">
        {/* Search */}
        <div className="flex min-w-[220px] flex-1 items-center gap-2.5 rounded-full border border-line bg-white px-4 py-2.5">
          <MagnifyingGlassIcon className="h-4 w-4 text-muted-300" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search destinations, regions…"
            className="flex-1 border-none bg-transparent text-[14.5px] text-ink outline-none placeholder:text-muted-300"
          />
        </div>

        {/* Difficulty chips */}
        <div className="flex flex-wrap items-center gap-[7px]">
          {DIFFICULTIES.map((d) => {
            const active = difficulty === d;
            return (
              <button
                key={d}
                onClick={() => setDifficulty(d)}
                className={`rounded-full border px-[15px] py-2.5 text-[13.5px] font-semibold transition-colors ${
                  active
                    ? "border-secondary-400 bg-secondary-400 text-white"
                    : "border-line bg-white text-muted hover:border-secondary-400"
                }`}
              >
                {d}
              </button>
            );
          })}
        </div>

        {/* Sort */}
        <select
          value={sort}
          onChange={(e) => setSort(e.target.value as SortKey)}
          className="cursor-pointer rounded-full border border-line bg-white px-[18px] py-2.5 text-[14px] font-semibold text-ink outline-none"
        >
          {SORTS.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterBar;
